import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Reactive `window.matchMedia`. Returns a ref tracking whether `query` currently
 * matches, updated only when the query crosses its breakpoint (not on every resize).
 *
 * Note: breakpoint values are not shared with SCSS, so keep the pixel value in the
 * query string in sync with the corresponding `$breakpoint-*` variable.
 */
export function useMediaQuery(query: string) {
  const matches = ref(false)
  let mql: MediaQueryList | null = null
  const update = (event: MediaQueryListEvent | MediaQueryList) => {
    matches.value = event.matches
  }

  onMounted(() => {
    mql = window.matchMedia(query)
    update(mql)
    mql.addEventListener('change', update)
  })

  onUnmounted(() => {
    mql?.removeEventListener('change', update)
  })

  return matches
}
